import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTimelineDetailsGetAsyncSlice } from './get';

export const coreTimelineDetailsReducers = combineReducers({
	get: coreTimelineDetailsGetAsyncSlice.asyncReducers
});

export const coreTimelineDetailsWatchers = combineAllWatchers([ coreTimelineDetailsGetAsyncSlice.asyncWatchers ]);
